export const reviewLp = {
  home: {
    mainImageAlt: "レビュー投稿で50ポイントプレゼント",
  },
  steps: {
    reviewSubmissionTitle: "レビュー投稿までの流れ",
    emailSubmissionTitle: "メール送信までの流れ",
    alt1: "レビュー手順1",
    alt2: "レビュー手順2",
    alt3: "レビュー手順3",
    alt4: "レビュー手順4",
    alt5: "レビュー手順5",
  },
  about: {
    title: "キャンペーン詳細",
    conditionsTitle: "50ポイント付与の条件",
    condition1: "本キャンペーンはお1人様1回限りとなります。",
    condition2: "複数アカウントでの参加は対象外となります。",
    condition3:
      "星だけ（コメントなし）、非公開のレビューは対象外となります。10文字以上のコメントを含めたレビューを投稿してください。",
    flowTitle: "ポイント付与までの流れ",
    flow1: "ストアにてレビューを投稿",
    flow2:
      "投稿完了後、ストアの「レビューを書く」または「フィードバックを編集」をタップして投稿したレビューを表示",
    flow3Prefix: "こちらの",
    flow3Link: "「お問い合わせ」",
    flow3Suffix: "より、以下2点を送信",
    flow3Sub1: "投稿したレビューのスクリーンショット画像を添付",
    flow3Sub2: "本文に「投稿完了しました」と記載",
    flow4: "内容確認後、50ポイントを付与いたします",
    pointsTitle: "ポイント付与について",
    points1: "付与対応は順次対応となります。",
    points2: "付与はお1人様1回までとなります。",
    points3:
      "付与されたポイントはマイページ＞所持ポイントよりご確認いただけます。",
    notesTitle: "注意事項",
    note1:
      "特典付与完了までの期間に退会されたお客さまは、特典付与の対象外となる場合があります。",
    note2:
      "複数アカウントを用いたキャンペーン参加や悪質な行為は、利用制限の対象となります。",
    note3: "本キャンペーンは予告なく変更・中止・延長する場合があります。",
  },
  faq: {
    title: "よくある質問",
    q1: "レビューを投稿したのにポイントが付与されません。",
    a1: "アプリ内の「お問い合わせ」よりご連絡ください。",
    a1Detail: "その際、投稿完了画面のスクリーンショットを添付し、本文に",
    a1Bold: "「投稿完了しました」",
    a1DetailSuffix: "とご記載ください。",
    q2: "どこから「お問い合わせ」を送ればいいですか？",
    a2: "アプリ内の「お問い合わせ」よりご連絡ください。",
    q3: "ポイント付与にはどれくらいかかりますか？",
    a3: "お問い合わせ内容を確認後、順次付与いたします。混雑状況により反映まで時間がかかる場合があります。",
    q4: "スクリーンショットは何を撮ればいいですか？",
    a4: "ストアの「レビューを書く」または「フィードバックを編集」をタップして投稿したレビューが表示された画面のスクリーンショットをご用意ください。",
    q5: "1人1回とはどういう意味ですか？",
    a5Prefix: "本キャンペーンのポイント付与は、",
    a5Bold: "1アカウントにつき1回限り",
    a5Suffix: "です。過去に同様の付与を受けた場合、追加付与はできません。",
    q6: "星だけ（コメントなし）、非公開のレビューでも対象ですか？",
    a6Prefix: "星だけ（コメントなし）、非公開のレビューは",
    a6Bold: "ポイント付与の対象外",
    a6Suffix:
      "です。10文字以上のコメントを含めた公開レビューを投稿してください。",
  },
  fixedButton: {
    heading: "＼ 全員もらえる！50ポイント ／",
    button: "レビューを書く",
  },
} as const;
